import { isValidElement } from 'react';
/** Source: https://github.com/sunknudsen/react-node-to-string/blob/master/src/index.ts */
export const reactNodeToString = function (reactNode) {
    let string = '';
    if (typeof reactNode === 'string') {
        string = reactNode;
    }
    else if (typeof reactNode === 'number') {
        string = reactNode.toString();
    }
    else if (reactNode instanceof Array) {
        reactNode.forEach(function (child) {
            string += reactNodeToString(child);
        });
    }
    else if (isValidElement(reactNode)) {
        string += reactNodeToString(reactNode.props.children);
    }
    return string;
};
//# sourceMappingURL=reactNodeToString.js.map